import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './HoldingsRow.css';
import ReactTooltip from 'react-tooltip';

class HoldingsRow extends Component {

  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-';
  }

  getTip(holding, allFunds, fundTickers) {
    const findMe = holding.name;
    const allTips = [];

    allFunds.map((fund, idx) => {
      for (let i = 0; i < fund.length; i++) {
        if (fund[i].name === findMe) {
          allTips.push({ ticker: fundTickers[idx], name: fund[i].name.split('|').pop().replace('&amp;', '&'), weight: this.formatPercent(fund[i].weight) });
        }
      }
    });

    const tickerWeight = allTips.map(function (t) {
      return (`${t.ticker} : ${t.weight}<br/>`);
    }).join('');

    return (
      `<strong>${allTips[0].name}</strong><br/>${tickerWeight}`
    );
  }

  render() {
    const {
      fundRows,
      idx,
      type,
      x,
      tickers
    } = this.props;

    const rowIndex = idx;
    const rowIndex2 = x;
    const allFunds = fundRows;
    const fundTickers = tickers;

    const row1 = fundRows.map((value, colIdx) => {
      const size = value.length;
      if (size > rowIndex) {
        return (
          <Fragment key={`${rowIndex}-${colIdx}`}>
            <td className='textLeft' data-tip data-for={`holdings ${rowIndex}-${colIdx}`} >
              {value[rowIndex].name.split('|').pop().replace('&amp;', '&')}
            </td>
            <td className='textCenter' data-tip data-for={`holdings ${rowIndex}-${colIdx}`} >
              {isNaN(value[rowIndex].weight)
                ? '-'
                : this.formatPercent(value[rowIndex].weight)}
              <React.Fragment>
                <ReactTooltip id={`holdings ${rowIndex}-${colIdx}`} type='light' className="holdingstip" effect="float">
                  <div dangerouslySetInnerHTML={{ __html: this.getTip(value[rowIndex], allFunds, fundTickers) }} />
                </ReactTooltip>
              </React.Fragment>
            </td>
          </Fragment>
        );
      } else {
        return (
          <Fragment key={`${rowIndex}-${colIdx}`}>
            <td className='textLeft'></td>
            <td className='textLeft'></td>
          </Fragment>
        );
      }
    });

    const row2 = fundRows.map((value, colIdx) => {

      const size = value.length;

      if (size > rowIndex) {
        // {value.map((item,index)=>{ 
        return (
          <Fragment key={`${rowIndex}-${colIdx}`}>
            <td className='textLeft' data-tip data-for={`holdings ${rowIndex}-${colIdx}`} >
              {value[rowIndex].name.split('|').pop().replace('&amp;', '&')}
            </td>
            <td className='textCenter' data-tip data-for={`holdings ${rowIndex2}-${colIdx}`} >
              {isNaN(value[rowIndex].weight)
                ? '-'
                : this.formatPercent(value[rowIndex].weight)}
              <React.Fragment>
                <ReactTooltip id={`holdings ${rowIndex}-${colIdx}`} type='light' className="holdingstip" effect="float">
                  <div dangerouslySetInnerHTML={{ __html: this.getTip(value[rowIndex], allFunds, fundTickers) }} />
                </ReactTooltip>
              </React.Fragment>
            </td>
          </Fragment>
        )
        // })};
      } else {
        return (
          <Fragment key={`${rowIndex}-${colIdx}`}>
            <td className='textLeft'></td>
            <td className='textLeft'></td>
          </Fragment>
        );
      }
    });

    const subTotal = fundRows.map((value, cnt) => {
      let subTot = 0;
      const x = value.length;
      for (let i = 0; i < value.length && i < 10; i++) {
        subTot = subTot + value[i].weight;
      }

      if (x >= 0) {
        return (
          <Fragment key={`${idx}-${subTot}`}>
            <td className={`subTotalTextLeft ${cnt !== 0 ? 'holdingsBorderleft' : ''}`}>Total</td>
            <td className='subTotalTextCenter'>
              {isNaN(subTot) ? '-' : this.formatPercent(subTot)}
            </td>
          </Fragment>
        );
      } else {
        return null;
      }
    });

    if (fundRows && type === 'dataRow') {
      return (
        <tr key='topten-row1'>
          <Fragment>{row1}</Fragment>
        </tr>
      );
    } else if (fundRows && type === 'total') {
      return (
        <tr key='topten-total'>
          <Fragment>{subTotal}</Fragment>
        </tr>
      );
    } else if (fundRows && type === 'dataRow2') {
      return (
        <tr key='topten-total'>
          <Fragment>{row2}</Fragment>
        </tr>
      );
    } else {
      return null;
    }
  } //render
}//class

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
  };
}

export default connect(mapStateToProps, {
})(HoldingsRow);
